import request from '@/util/request';
import qs from 'qs';

export const getRenterList = (params, options) =>
  request.get('/api/v4ward/departmentRenter/getList', Object.assign({}, options, { params }));
export const getList = (params, options) =>
  request.get('/api/v4ward/departmentRenter/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/departmentRenter/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/departmentRenter/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/departmentRenter/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/departmentRenter/submit', params, options);

export const getDepartmentRenterByRoommateName = (params, options) =>
  request.get(
    '/api/v4ward/departmentRenter/getDepartmentRenterByRoommateName',
    Object.assign({}, options, { params })
  );
export const getRecordInfo = (params, options) =>
  request.get('/api/v4ward/departmentRentRecord/info', Object.assign({}, options, { params }));
export const getDepartmentRenterCheckOutAmount = (params, options) =>
  request.get(
    '/api/v4ward/departmentRenter/getDepartmentRenterCheckOutAmount',
    Object.assign({}, options, { params })
  );
export const departmentRenterCheckOutBill = (params, options) =>
  request.get(
    '/api/v4ward/departmentRenter/departmentRenterCheckOutBill',
    Object.assign({}, options, { params })
  );
export const departmentRenterRoomChange = (params, options) =>
  request.get(
    '/api/v4ward/departmentRenter/departmentRenterRoomChange',
    Object.assign({}, options, { params })
  );
export const getDictionaryWithIntKey = (code, options) =>
  request.get(
    '/api/blade-system/dict/dictionaryWithIntKey?code=' + code,
    Object.assign({}, options, {})
  );
export const getRentAmount = (params, options) =>
  request.get('/api/v4ward/departmentRenter/getRentAmount', Object.assign({}, options, { params }));
export const getDownloadList = (params, options) =>
  request.get('/api/v4ward/departmentRenter/download', Object.assign({}, options, { params }));

export const getAllFeeItem = (params, options) =>
  request.get('/api/v4ward/departmentRenter/getAllFeeItem', Object.assign({}, options, { params }));
